import styled from "@emotion/styled";

/**
 * Holds content and contains no padding.
 */
export const DefaultContainer = styled.div`
  margin: 0;
`;
